var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"device-monitor_col",class:{ inline: _vm.isInline }},[_c('el-image',{attrs:{"src":_vm.url,"preview-src-list":[_vm.url]}}),_c('MultiLineText',{attrs:{"text":_vm.text,"share-out":true}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }